import { render, staticRenderFns } from "./kesenkisianaliz.vue?vue&type=template&id=bc97f5ee&"
import script from "./kesenkisianaliz.vue?vue&type=script&lang=js&"
export * from "./kesenkisianaliz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports